// Procedência Silverlight — SSOT usado pela UI (pill "Silverlight" + pseudo-grupo
// no modal Estudos). Chave do registry → classe FML de origem no app legado.
// Derivado dos 35 testes de oráculo (src/chartLib/lib/calculator/__tests__/
// *.silverlight.test.js) e do de-para em docs/research-unification-all-charts/
// validacao-final/README.md. Indicador migrado novo = acrescentar 1 linha aqui
// (passo da skill migrate-indicator-fromSilverL8); pill e pseudo-grupo derivam
// desta tabela sozinhos. NÃO listar os que já tinham paridade antes da migração.
export const silverlightOrigin = {
  accumDist: "AD",
  aroonOsc: "AroonOsc",
  b3612: "B3612",
  bbi: "BBI",
  bbiBoll: "BBIBOLL",
  bias: "BIAS",
  cdp: "CDP",
  chaikinMoneyFlow: "CMF",
  chaikinVolatility: "VOLATI",
  dbcd: "DBCD",
  ddi: "DDI",
  didiHist: "DIDIHIST",
  difusorFluxo: "DF",
  dpo: "DPO",
  fastSto: "FastSTO",
  highLowMa: "HighLow",
  linRegrChannel: "LinRegr",
  lwr: "LWR",
  massIndex: "MASS",
  micd: "MICD",
  mike: "MIKE",
  rsiCutler: "RSICutler",
  sar: "SAR",
  so: "SO",
  sobv: "SOBV",
  sr5: "SR5",
  srdm: "SRDM",
  sroc: "SROC",
  stochRsi: "StochRSI",
  tema: "TEMA",
  vhf: "VHF",
  vmacd: "VMACD",
  volHistHisto: "VolHistHisto",
  vr: "VR",
  vrsi: "VRSI",
  vstd: "VSTD",
  wvad: "WVAD",
};

export const isFromSilverlight = (indicatorKey) =>
  indicatorKey in silverlightOrigin;
